import {useCallback, useState} from "react";
import axios from "axios";
import {getAccessToken} from "../../../api/getAccessToken.js";
import {getCurrentUserEmail} from "../../auth/accessTokenValidator.js";

export const useFetchSubscribedUsers = () => {
    const [loading, setLoading] = useState(true)
    const [subscribedUsers, setSubscribedUsers] = useState([])

    const fetchSubscribedUsers = useCallback(async () => {
        setLoading(true)

        const result = await axios.get(`${process.env.REACT_APP_RIS_API_URL}/intelligence/users/users`, {
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getAccessToken()}`
            }
        })

        setSubscribedUsers(result.data.map((d, index) => ({
            ...d,
            id: index,
        })))

        setLoading(false)

    }, [])

    const fetchDefaultUserGroups = useCallback(async (userSalesforceId, companyId) => {
        const {data} = await axios.get(`${process.env.REACT_APP_RIS_API_URL}/intelligence/users/default-user-groups`, {
            params: {user_contact_id: userSalesforceId, company_id: companyId},
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getAccessToken()}`
            }
        })

        return data ?? []
    }, [])

    const upsertUsers = async (users) => {
        const token = getAccessToken()
        const currentUserEmail = getCurrentUserEmail(token)

        return await axios.put(`${process.env.REACT_APP_RIS_API_URL}/intelligence/users/upsert`, {
            users: users,
            updated_by: currentUserEmail
        }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`
            },
        }).then(() => window.location.reload())
    }

    return {
        subscribedUsers,
        loading,
        setSubscribedUsers,
        fetchSubscribedUsers,
        fetchDefaultUserGroups,
        upsertUsers
    }
}